import React, { useEffect } from "react";
import { Trans } from "react-i18next";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PAGE } from "src/constants/page";

import "../styles/NetworkError.scss";

const NetworkError = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    setTimeout(() => {
      navigate(PAGE.GLOBAL_HOME);
    }, 1000);
  };

  const handleLoad = () => {
    navigate(PAGE.GLOBAL_HOME);
  };
  const handleError = () => {
    // do nothing
  };

  return (
    <div className="network-error">
      <div className="network-error-inner">
        <div className="text-center mt-5">
          <div className="image-container mb-1">
            <svg
              width="114"
              height="86"
              viewBox="0 0 114 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M55.4293 0.519707C49.3591 0.791634 43.8953 2.38919 38.7489 5.39735C38.2898 5.6636 37.8704 5.91287 37.8194 5.95252C37.7344 6.00918 38.1481 6.44539 41.1464 9.45355C43.0338 11.3457 44.6095 12.8923 44.6491 12.8923C44.6888 12.8923 44.7682 12.8583 44.8305 12.8129C44.8928 12.7733 45.2783 12.5863 45.6807 12.3994C50.64 10.1107 56.0415 9.40823 61.3409 10.3713C65.8128 11.1871 70.1317 13.2435 73.538 16.178C74.2352 16.7785 75.5671 18.0985 76.1849 18.8009C79.2909 22.319 81.4503 26.8284 82.2325 31.4171C82.5215 33.0939 82.5612 33.6548 82.5895 36.0171L82.6179 38.2662L86.8801 38.2888C90.9212 38.3058 91.1706 38.3172 91.8451 38.4305C94.3503 38.861 96.334 39.7051 98.2894 41.1667C98.9185 41.6426 100.29 42.9739 100.755 43.5687C102.467 45.7554 103.47 48.1631 103.782 50.8257C103.895 51.7717 103.861 53.6865 103.725 54.542C103.39 56.604 102.693 58.3999 101.571 60.1107C100.318 62.0142 98.8052 63.4248 96.5834 64.7561C96.504 64.8014 97.0538 65.3736 99.9161 68.2345L103.339 71.6562L103.923 71.2086C106.207 69.4808 108.185 67.3337 109.71 64.9147C112.861 59.9408 114.001 53.9585 112.924 48.1008C111.881 42.447 108.645 37.2408 103.997 33.7284C100.489 31.0828 96.368 29.4796 91.9414 29.0434C91.6694 29.0151 91.4313 28.9811 91.4143 28.9641C91.3973 28.9471 91.318 28.6582 91.2443 28.3183C89.6516 21.2313 86.0696 14.943 80.8552 10.0767C74.9493 4.55891 67.5415 1.27316 59.5385 0.62735C58.5126 0.542374 56.2228 0.485718 55.4293 0.519707Z"
                fill="#8C8C8C"
              />
              <path
                d="M17.1262 3.53358L14.1279 6.5304L20.6289 12.9886L27.1299 19.4468L26.2287 19.5148C18.6451 20.087 11.6227 23.656 6.70305 29.4457C2.89427 33.9211 0.666816 39.2293 0.0716951 45.2116C-0.0359935 46.3163 -0.01899 49.4094 0.100034 50.5085C0.751834 56.3888 2.86026 61.4024 6.59536 65.9175C7.28683 66.7559 9.21956 68.6877 10.0584 69.3845C14.5416 73.1008 19.6257 75.2592 25.3615 75.888C26.7955 76.0467 28.8869 76.058 55.826 76.058H83.7117L88.4274 80.7713L93.1487 85.4903L96.1526 82.4879L99.1565 79.4854L59.6688 40.0167C37.9441 18.3025 20.1641 0.542412 20.1471 0.542412C20.1301 0.542412 18.7698 1.8907 17.1262 3.53358ZM55.3443 47.7042L74.2465 66.5973L50.4416 66.5803C28.2068 66.569 26.5914 66.5576 25.985 66.467C23.6442 66.1158 21.8531 65.5776 20.0054 64.6655C14.0542 61.748 10.1094 56.0206 9.49161 49.4038C9.41226 48.5087 9.4236 46.7015 9.51995 45.7894C9.92804 41.9372 11.3847 38.5041 13.8615 35.5526C16.8201 32.0233 21.003 29.7006 25.5826 29.0321C26.8068 28.8508 27.5266 28.8282 32.1062 28.8168L36.4421 28.8112L55.3443 47.7042Z"
                fill="#8C8C8C"
              />
            </svg>
          </div>
          <div className="text-container">
            <div className="heading mt-33 mb-2">
              <Trans i18nKey={"error.internet_unavailable"} />
            </div>
            <div className="mb-3">
              <Trans i18nKey={"error.check_your_connection"} />
            </div>

            <Button className="text-not-button-go-home" onClick={handleRetry}>
              <Trans i18nKey={"retry"} />
            </Button>
          </div>
          <img
            style={{ visibility: "hidden" }}
            src={"../icons/network_error.svg?ts=" + new Date()}
            alt=""
            onLoad={handleLoad}
            onError={handleError}
          />
        </div>
      </div>
    </div>
  );
};

export default NetworkError;
